const notificationStates = {
  NOT_SHOW: "NOT_SHOW",
  SHOW: "SHOW",
  READ: "READ",
};

export { notificationStates };
